import store from "../store";
import { Plugins } from "@capacitor/core";

const { Storage } = Plugins;

export default {
    setStoreData: function () {
        return new Promise((resolve) => {
            Promise.all([
                Storage.get({ key: "contracts" }).then(({ value: val }) => {
                    if (val !== null && val !== undefined && val !== "") {
                        store.commit("setContracts", JSON.parse(val));
                    }
                }),
                Storage.get({ key: "checklists" }).then(({ value: val }) => {
                    if (val !== null && val !== undefined && val !== "") {
                        store.commit("setChecklists", JSON.parse(val));
                    }
                }),
            ]).finally(() => {
                resolve();
            });
        });
    },
    removeStoreData: function () {
        Storage.remove({ key: "contracts" }).then(() => {
            store.commit("setContracts", {});
        });
        Storage.remove({ key: "checklists" }).then(() => {
            store.commit("setChecklists", {});
        });
    },
};
